var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-designs-layout-view"
  }, [_c('ul', {
    staticClass: "uk-margin-medium-bottom",
    attrs: {
      "uk-tab": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'product-design-artists'
      },
      "active-class": "uk-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.productDesignArtists')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'product-design-categories'
      },
      "active-class": "uk-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.productDesignCategories')))])])], 1), _vm._v(" "), _c('router-view')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4298039a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/ProductDesignsView.vue
// module id = 1957
// module chunks = 0